import {createI18n} from 'vue-i18n';

// TODO: when we have many languages, we should load lazily, see e.g. https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
import de from './locales/de.json';
import de_DE from './locales/de-DE.json';
import en from './locales/en.json';
import en_GB from './locales/en-GB.json';

const messages = {de, en, 'de-DE': de_DE, 'en-GB': en_GB};

function checkDefaultLanguage() {
    let matched = null;
    let languages = Object.getOwnPropertyNames(messages);
    languages.forEach(lang => {
        if (lang === navigator.language) {
            matched = lang;
        }
    });
    if (!matched) {
        languages.forEach(lang => {
            let languagePartials = navigator.language.split('-')[0];
            if (lang === languagePartials) {
                matched = lang;
            }
        });
    }
    return matched;
}

const i18n = createI18n({
    legacy: true, // keep Options API style: $t, this.$i18n (vue-i18n v11 default changed)
    locale: checkDefaultLanguage(),
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE,
    messages
});

// Shim for $tc / tc, which vue-i18n v10 dropped from the Legacy API.
// Forward to $t. Note that arg order differs when named params are involved:
//   $tc(key, count)          → $t(key, count)
//   $tc(key, count, {named}) → $t(key, {named}, count)   ← reshuffled
export function tc(key, arg1, arg2) {
    const {t} = i18n.global;
    if (arg2 !== undefined && typeof arg1 === 'number' && arg2 !== null && typeof arg2 === 'object')
        return t(key, arg2, arg1);
    return t(key, arg1);
}

export default i18n;

